import { Box, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { IconWithText } from '../../comps/IconWithText'
import { ServiceHighlights } from '../../comps/ServiceHighlight'
import { VerticleDrawerDialog } from '../../comps/VerticleDrawerDialog'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { getWindow, nativeJSComm, nativeJSMapper } from '../../util/WebFns'

export const BbpsLoadInitial = () => {
  const navigation = useNavigation()
  const { agentOnboarding, checkWhetherAgentExists, agentStore, agentOnboardingV3 } = useStores((root) => ({
    agentOnboarding: root.BillPaymentAgentOnboard.agentOnboarding,
    checkWhetherAgentExists: root.BillPaymentAgentOnboard.checkWhetherAgentExists,
    agentStore: root.agent, // Access the Agent store
    agentOnboardingV3: root.BillPaymentAgentOnboard.agentOnboardingV3,
  }))

  const { BillPaymentAgentOnboard, message } = useStores((store) => ({
    BillPaymentAgentOnboard: store.BillPaymentAgentOnboard,
    message: store.message,
  }))

  const [agentExistsHandler, doesAgentExists] = useLazyApiData(checkWhetherAgentExists)

  console.log('BPBSLoadinitial screen:::')
  console.log('loadinitial screen:::')
  const [activeTab, setActiveTab] = useState('payBills')
  const [showInactivityDialog, setShowInactivityDialog] = useState(false)
  const [checked, setChecked] = useState(false)

  const handleInactivityDialogPress = () => {
    setShowInactivityDialog(false)
    if (getWindow().AepsWebViewInterface) {
      nativeJSComm(nativeJSMapper.closeWebView)
    } else {
      console.warn('Exiting application (Mock call for native environment)')
      // navigation.goBack();
    }
  }
  const handleRegisterDialogPress = () => {
    // setShowRegisterDialog(false)
    // if (getWindow().AepsWebViewInterface) {
    //   nativeJSComm(nativeJSMapper.closeWebView)
    // } else {
    //   console.warn('Exiting application (Mock call for native environment)')
    //   // navigation.goBack();
    // }
  }
  console.log('checkkkkkkhere::')

  const navigateToHome = () => {
    navigation.reset({
      index: 0,
      routes: [{ name: Screens.BBPS_HOME_SCREEN as never }],
    })
  }

  const handleHistoryPress = () => {
    setShowInactivityDialog(true)
  }

  useEffect(() => {
    agentExistsHandler()
  }, [])

  // 1. Add a specific handler

  const toggleCheckbox = (val: boolean) => {
    // Explicitly set the value provided by the component
    console.log('Checkbox toggled from:', val, checked)
    setChecked(val)
  }

  useEffect(() => {
    if (doesAgentExists.state === 'fulfilled' && doesAgentExists.data) {
      const agentData = doesAgentExists?.data
      const agentStatus = doesAgentExists.data?.status
      const agentReasonCode = doesAgentExists?.data?.reasonCode
      console.log('checkWhetherTheAgentExistsApi fulfilled. Status:', agentStatus)
      console.log('Agent Check Results:', { agentStatus, agentReasonCode })
      console.log(agentData, 'agentData::')

      console.log('Avinash see what value of agentStatus', agentStatus)
      console.log('Avinash see what value of agentReasonCode', agentReasonCode)
      console.log('Avinash see what value of agentData', agentData)
      console.log(agentStatus, 'agentStatus:::::')

      if (agentStatus === 'PENDING') {
        setShowInactivityDialog(true)

        // setOpenConfirmDialog(true)
      } else if (String(agentReasonCode) === '1') {
        setShowInactivityDialog(true)
        // setOpenConfirmDialog(true)
      } else if (agentStatus === 'ACTIVE' || agentStatus === 'ACCEPTED') {
        // setActiveTab('payBills')
        navigateToHome()
      } else if (agentStatus === 'NOT_AVAILABLE') {
        // setShowRegisterDialog(true)
        // RootStore.message.setMessage('', 'NEGATIVE')
        // console.warn('')
        // console.log('Please agree to the Terms & Conditions, Terms & Conditions not accepted.')
      }
    } else if (doesAgentExists.state === 'rejected') {
      console.log('checkWhetherTheAgentExistsApi failed:', doesAgentExists.data)
    }
  }, [doesAgentExists.state, doesAgentExists.data])

  const handlePendingDialogPrimaryButtonPress = () => {
    // setOpenConfirmDialog(false)
    setShowInactivityDialog(false)
    if (getWindow().AepsWebViewInterface) {
      nativeJSComm(nativeJSMapper.closeWebView)
    } else {
      console.warn('Exiting application (Mock call for native environment)')
      // navigation.goBack();
    }
  }
  const searchList = (tnxId) => {
    console.log(tnxId)
  }

  const handlePress = () => {
    setActiveTab('history')
    // setShowInactivityDialog(true)
  }

  const onPrimaryButtonPress = async () => {
    const dataForApi = {}
    if (!checked) {
      RootStore.message.setMessage('Please agree to the Terms & Conditions', 'NEGATIVE')
      console.warn('Terms & Conditions not accepted.')
      console.log('Please agree to the Terms & Conditions, Terms & Conditions not accepted.')
      // Assuming you have a message store to show toasts
      return console.warn('Please agree to Terms & Conditions')
    }

    try {
      console.log('Calling getAgentUserInformationApiV5...')
      const response = await agentOnboarding(dataForApi)
      const status = response?.status
      const reasonCode = response?.reasonCode
      const reasonMessage = response?.reasonMessage
      console.log('agentOnboardingV5API Response Avinash ', response)
      console.log('agentOnboardingV5API Response Avinash reasonMessage ', reasonMessage)
      console.log('agentOnboardingV5API Response Avinash  reasonCode', reasonCode)
      if (status === 'ACTIVE' || String(reasonCode) === '1' || status === 'ACCEPTED') {
        console.log('Agent Onboarding: ACCEPTED. Navigating to Home Screen.')
        console.log('Agent Onboarding: ACCEPTED. Navigating to Home Screen.')
        navigation.reset({
          index: 0,
          routes: [{ name: Screens.BBPS_HOME_SCREEN as never }],
        })
        // setOpenConfirmDialog(true)
      } else if (status === 'ALREADY_ONBOARDED' || reasonCode === '3') {
        console.log(`Agent Onboarding: ${status} and reasonCode ${reasonCode} `)
        RootStore.message.setMessage(`Agent Onboarding: ${status} and reasonCode ${reasonCode}`, 'NEGATIVE')
        setShowInactivityDialog(true)
      } else if (status === 'PENDING') {
        console.log('Agent Onboarding: PENDING. Showing Confirmation Dialog.')
        setShowInactivityDialog(true)
      } else {
        RootStore.message.setMessage('Failed Agent Onboarding', 'NEGATIVE')
        console.warn(`Agent Onboarding: Unexpected status received: ${status}`)
      }
      // navigation.navigate(Screens.CUSTOMER_ONBORD as never)
    } catch (error) {
      RootStore.message.setMessage('Agent Onboarding Failed', 'NEGATIVE')
      console.error('Agent Onboarding Failed:', error)
    }
  }

  //   const onPrimaryButtonPress = async () => {
  //     const dataForApi = {}
  //     if (!checked) {
  //       RootStore.message.setMessage('Please agree to the Terms & Conditions', 'NEGATIVE')
  //       console.warn('Terms & Conditions not accepted.')
  //       console.log('Please agree to the Terms & Conditions, Terms & Conditions not accepted.')
  //       return
  //     }
  //     try {
  //       console.log('Calling getAgentUserInformationApiV5...')
  //       // const agentInfoV3Response = await agentStore.getAgentUserInformationApiV3()
  //       // console.log("agentInfoV3Response", agentInfoV3Response)
  //       // const agentData = agentInfoV3Response

  // //       if (!agentData) {
  // //         console.log("Failed to retrieve V3 agent data for onboarding.", agentInfoV3Response)
  // //         throw new Error('Failed to retrieve V3 agent data for onboarding.')
  // //       }

  //       // agentStore.updateAgentInfoV3(agentData)
  //       // console.log('AgentInfoV3 updated successfully.')
  //       // console.log(' see what data we are getting from AgentInfoV3 ', agentInfoV3Response)

  //       const response = await agentOnboarding(dataForApi)
  //       const status = response?.status
  //       const reasonCode = response?.reasonCode
  //       const reasonMessage = response?.reasonMessage
  //       console.log('agentOnboardingV5API Response Avinash ', response)
  //       console.log('agentOnboardingV5API Response Avinash reasonMessage ', reasonMessage)
  //       console.log('agentOnboardingV5API Response Avinash  reasonCode', reasonCode)
  //       if (status === 'ALREADY_ONBOARDED' || reasonCode === '3') {
  //         console.log('Agent Onboarding: ACCEPTED. Navigating to Home Screen.')
  //         navigation.reset({
  //           index: 0,
  //           routes: [{ name: Screens.BBPS_HOME_SCREEN as never }],
  //         })
  //       } else if (status === 'ACCEPTED') {
  //         console.log('Agent Onboarding: ACCEPTED. Navigating to Home Screen.')
  //         setOpenConfirmDialog(true)
  //       } else if (status === 'PENDING') {
  //         console.log('Agent Onboarding: PENDING. Showing Confirmation Dialog.')
  //         setOpenConfirmDialog(true)
  //       } else {
  //         console.warn(`Agent Onboarding: Unexpected status received: ${status}`)
  //       }
  //     } catch (error) {
  //       console.error('Agent Onboarding Failed (API or Network Error):', error)
  //     }
  //   }

  console.log('checkkherreeee:::::')

  return (
    <Container showFooter={false} overflow="auto">
      <>
        <Box width={'100%'} flex={1} justifyContent={'space-between'}>
          <Box>
            <TextNew fontSize={22} lineHeight={28} color="BLACK">
              {'Become a Bill Payment Agent with zero fees & grow your earnings'}
            </TextNew>
            <ServiceHighlights
              containerStyle={{ marginTop: 30, overflow: 'scroll', width: '100%' }}></ServiceHighlights>
            <Box marginBottom={20} marginTop={20} width={'100%'}>
              <IconWithText></IconWithText>
            </Box>
            <Box width={'100%'} marginBottom={40}>
              <AepsCheckBox
                text={'I agree to bill payment Terms & Conditions'}
                checked={checked}
                onChange={toggleCheckbox} // Use the specific handler
                alignItems="center"
              />
            </Box>
          </Box>
          <Box width={'100%'}>
            <AepsButton onPress={onPrimaryButtonPress} title={'Register Now'} disabled={false} />
          </Box>
        </Box>
      </>

      <VerticleDrawerDialog
        show={showInactivityDialog}
        type="POSITIVE"
        onPress={handleInactivityDialogPress}
        message={'message'}>
        <TextNew fontSize={25} lineHeight={28} color="BLACK">
          {'Bill Payment Agent request is pending'}
        </TextNew>
        <TextNew fontSize={12} lineHeight={18} color="BLACK">
          {"Request processing will take 2-3 working days. you'll be notified once approved for Bill Payment."}
        </TextNew>
        <Box marginBottom={20}></Box>
        <Box width={'100%'}>
          <AepsButton onPress={handlePendingDialogPrimaryButtonPress} title={'Okay Got it.'} disabled={false} />
        </Box>
      </VerticleDrawerDialog>

      {/* <Box>
          <VerticleDrawerDialog
            show={showRegisterDialog}
            type="POSITIVE"
            onPress={handleRegisterDialogPress}
            message={''}>
            <Box width={'100%'} flex={1} justifyContent={'space-between'}>
              <Box>
                <TextNew fontSize={22} lineHeight={28} color="BLACK">
                  {'Become a Bill Payment Agent with zero fees & grow your earnings'}
                </TextNew>
                <ServiceHighlights
                  containerStyle={{ marginTop: 30, overflow: 'scroll', width: '100%' }}></ServiceHighlights>
                <Box marginBottom={20} marginTop={20} width={'100%'}>
                  <IconWithText></IconWithText>
                </Box>
                <Box width={'100%'} marginBottom={40}>
                  <AepsCheckBox
                    text={'I agree to bill payment Terms & Conditions'}
                    checked={checked}
                    onChange={(isChecked: boolean) => setChecked(isChecked)}
                    alignItems="center"
                  />
                </Box>
              </Box>
              <Box width={'100%'}>
                <AepsButton onPress={onPrimaryButtonPress} title={'Register Now'} disabled={false} />
              </Box>
            </Box>
          </VerticleDrawerDialog>
        </Box> */}
    </Container>
  )
}

//   return (
//     <Container showFooter={true} overflow="auto">
//       {activeTab === 'payBills' && (
//         <>
//           <Box width={'100%'} flex={1} justifyContent={'space-between'}>
//             <Box>
//               <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                 {'Become a Bill Payment Agent with zero fees & grow your earnings'}
//               </TextNew>
//               <ServiceHighlights
//                 containerStyle={{ marginTop: 30 , width: '100%' }}></ServiceHighlights>
//               <Box marginBottom={20} marginTop={20} width={'100%'}>
//                 <IconWithText></IconWithText>
//               </Box>
//               <Box width={'100%'} marginBottom={40}>
//                 <AepsCheckBox
//                   text={'I agree to bill payment Terms & Conditions'}
//                   checked={checked}
//                   onChange={(isChecked: boolean) => setChecked(isChecked)}
//                   alignItems="center"
//                 />
//               </Box>
//             </Box>
//             <Box width={'100%'}>
//               <AepsButton onPress={onPrimaryButtonPress} title={'Register Now'} disabled={!checked} />
//             </Box>
//           </Box>

//         </>
//       )}
//       {activeTab === 'pending' && (
//         <>
//           <Box width={'100%'} flex={1} justifyContent={'space-between'}>
//             <Box>
//             <VerticleDrawerDialog
//               show={openConfirmDialog} // Your existing state
//               type="POSITIVE"
//               message={'Bill Payment Agent request status is PENDING'}
//               onPress={handlePendingDialogPrimaryButtonPress}>
//               <Box marginBottom={20}>
//                 <TextNew fontSize={25} lineHeight={28} color="BLACK">
//                   {'Bill Payment Agent request is pending'}
//                 </TextNew>
//               </Box>
//               <TextNew fontSize={12} lineHeight={18} color="BLACK">
//                 {"Request processing will take 2-3 working days. you'll be notified once approved for Bill Payment."}
//               </TextNew>
//               <Box marginBottom={20}></Box>
//               <Box width={'100%'}>
//                 <AepsButton onPress={handlePendingDialogPrimaryButtonPress} title={'Okay Got it.'} disabled={false} />
//               </Box>
//             </VerticleDrawerDialog>
//           </Box>
//             <Box width={'100%'}>
//               <AepsButton onPress={onPrimaryButtonPress} title={'Register Now'} disabled={!checked} />
//             </Box>
//           </Box>

//         </>
//       )}
//       {activeTab === 'history' && (
//         <>
//           <Box width={'100%'} flex={1} justifyContent={'space-between'}>
//             <Box>
//               <TextNew fontSize={22} lineHeight={28} color="BLACK">
//                 {'We will show History here'}
//               </TextNew>
//             </Box>
//             <Box width={'100%'}>
//               <AepsButton onPress={onPrimaryButtonPress} title={'Register Now'} disabled={false} />
//             </Box>
//           </Box>
//         </>
//       )}
//     </Container>
//   )
// }

// const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
// const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)

// const [lazygetProductListBC, getProductListBCHandler] = useLazyApiData(getProductListBC)
// lazygetProductListBC()
// useEffect(() => {
//   if (getProductListBCHandler.state === 'fulfilled') {
//     console.log('We are Entering BbpsLoadInitials Page')
//     const reasonCode = getProductListBCHandler?.data?.responseObj?.agent?.agentStatus?.reasonCode
//     console.log(reasonCode, 'reasonCode:::::')
//     navigation.reset({
//       index: 0,
//       routes: [
//         {
//           name: reasonCode === '3' ? (Screens.BBPS_HOME_SCREEN as never) : (Screens.CUSTOMER_ONBORD as never),
//         },
//       ],
//     })
//   }
// }, [getProductListBCHandler])

// const useLazyApiData = (apiFn) => {
//   const { fetchFavoriteTransactionsBC } = useStores((root) => ({
//     fetchFavoriteTransactionsBC: root.BillPaymentAgentOnboard.fetchFavoriteTransactionsBC,
//   }))

//   const [fetFavoriteTransaction, fetchFaviriteTransaction] = useLazyApiData(fetchFavoriteTransactionsBC)
//   console.log(fetFavoriteTransaction, 'doesAgentExists::')

//   const [data, setData] = useState(null)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)

//   const callApi = async () => {
//     setLoading(true)
//     setError(null)
//     try {
//       const mockData = await new Promise((resolve) =>
//         setTimeout(() => {
//           if (apiFn.name === 'fetchFavourites') {
//             resolve([
//               {
//                 id: '1',
//                 name: 'ICICI Bank FASTag',
//                 customerName: 'Prakash',
//                 vehicleNo: 'MH034589',
//                 lastLinked: 'O5 june 2025',
//               },
//               {
//                 id: '2',
//                 name: 'Airtel Postpaid',
//                 customerName: 'Rahul',
//                 mobileNo: '9876543210',
//                 lastLinked: '10 July 2025',
//               },
//             ])
//           } else if (apiFn.name === 'fetchRecentPayments') {
//             resolve([
//               {
//                 id: '3',
//                 name: 'BSES Rajdhani',
//                 customerName: 'Anil',
//                 accountNo: '12345678',
//                 lastLinked: '22 May 2025',
//               },
//               { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' },
//             ])
//           } else {
//             resolve([])
//           }
//         }, 1000),
//       )
//       setData(mockData)
//     } catch (err) {
//       setError(err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   return [data, callApi, loading, error]
// }
